<template>
  <div class="row mb20">
    <div v-if="getSelectedFilters" class="col-xs-12 col-md-12 col-lg-6">
      <label class="uppercase" for="">{{ $t("Choose size") }}</label>
      <base-select :options="sizes" class="mt5" :selected="getSelectedFilters" :disabled="isDisabled" @change="updateSize" />
    </div>
    <div class="col-xs-12 col-md-12 delivery-select" :class="[getSelectedFilters ? 'col-lg-6' : 'col-lg-12']">
      <label class="uppercase nowrap" for="">{{ $t("Delivery method") }}</label>
      <base-select :options="deliveries" class="mt5" :selected="getActiveDelivery" :disabled="isDisabled" @change="updateDelivery" />
    </div>
    <div v-if="getCurrentProduct.size_guide" class="col-xs-12 mt5 mb20 underline pointer" @click="$bus.$emit('modal-show', 'modal-size')">
      {{ $t('Size guide') }}
    </div>
  </div>
</template>

<script>
import BaseSelect from 'theme/components/core/blocks/Form/BaseSelect'
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import { mapGetters } from 'vuex'
import { filterChangedProduct } from '@vue-storefront/core/modules/catalog/events'

export default {
  name: 'SizeAndDelivery',
  components: {
    BaseSelect
  },
  props: {
    rentType: {
      type: String,
      default: 'single',
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration',
      getDeliveries: 'calendar/getDeliveries',
      isLogged: 'user/isLoggedIn',
      getUserBalance: 'user/getBalance'
    }),
    getSelectedFilters () {
      return getSelectedFiltersByProduct(this.getCurrentProduct, this.getCurrentProductConfiguration).size?.label
    },
    getActiveDelivery () {
      return this.$store.state.calendar.delivery
    },
    deliveries () {
      return this.getDeliveries.map(delivery => ({ label: this.deliveryBeautifier(delivery), value: delivery }))
    },
    sizes () {
      let sizes = getAvailableFiltersByProduct(this.getCurrentProduct)['size']
      let result = []
      sizes.map(size => result.push({ ...size, value: size.label }))
      return result
    },
    sizeLabels () {
      return this.sizes.map(size => size.label)
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    isDisabled () {
      return this.rentType === 'subscription' && (!this.isEnoughPoints || !this.isLogged)
    }
  },
  methods: {
    deliveryBeautifier (delivery) {
      return delivery === 'showroom'
        ? this.$t('In-store pickup')
        : this.$t('Courier')
    },
    updateDelivery (value) {
      if (value) this.$store.commit('calendar/updateDelivery', value)
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    },
    async updateSize (value) {
      const variant = this.sizes.find(size => size.label === value)
      const selectedConfiguration = Object.assign({ attribute_code: variant.type }, variant)
      await filterChangedProduct(selectedConfiguration, this.$store, this.$router)
      await this.$store.dispatch('stock/getQuantity')
      this.setAvaliableSourceCodes()
      this.updateDelivery()
    },
    setAvaliableSourceCodes () {
      if (this.getCurrentProduct.stock && this.getCurrentProduct.stock.source_codes && this.getCurrentProduct.stock.source_codes.length) {
        this.$store.commit('calendar/setAvailableDeliveries', this.getCurrentProduct.stock.source_codes)
      } else {
        this.$store.commit('calendar/setAvailableDeliveries', [])
      }
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    }
  }
}
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
.delivery-select {
  @media (max-width: 992px) {
    margin-top: 5px;
  }
}
</style>
